import createIcon from '../../createIcon';

/**
 * @component @name Brush
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy40OTkwMiAxNC4wMDA1QzUuODM5MDIgMTQuMDAwNSA0LjQ5OTAyIDE1LjM0MDUgNC40OTkwMiAxNy4wMDA1QzQuNDk5MDIgMTguMzEwNSAzLjMzOTAyIDE5LjAwMDUgMi40OTkwMiAxOS4wMDA1QzMuNDE5MDIgMjAuMjIwNSA0Ljk4OTAyIDIxLjAwMDUgNi40OTkwMiAyMS4wMDA1QzguNzA5MDIgMjEuMDAwNSAxMC40OTkgMTkuMjEwNSAxMC40OTkgMTcuMDAwNUMxMC40OTkgMTUuMzQwNSA5LjE1OTAyIDE0LjAwMDUgNy40OTkwMiAxNC4wMDA1Wk0yMS4yMDkgNC42MzA1NUwxOS44NjkgMy4yOTA1NUMxOS40NzkgMi45MDA1NSAxOC44NDkgMi45MDA1NSAxOC40NTkgMy4yOTA1NUw5LjQ5OTAyIDEyLjI1MDVMMTIuMjQ5IDE1LjAwMDVMMjEuMjA5IDYuMDQwNTVDMjEuNTk5IDUuNjUwNTUgMjEuNTk5IDUuMDIwNTUgMjEuMjA5IDQuNjMwNTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Brush = createIcon('Brush', [
  [
    'path',
    {
      d: 'M7.49902 14.0005C5.83902 14.0005 4.49902 15.3405 4.49902 17.0005C4.49902 18.3105 3.33902 19.0005 2.49902 19.0005C3.41902 20.2205 4.98902 21.0005 6.49902 21.0005C8.70902 21.0005 10.499 19.2105 10.499 17.0005C10.499 15.3405 9.15902 14.0005 7.49902 14.0005ZM21.209 4.63055L19.869 3.29055C19.479 2.90055 18.849 2.90055 18.459 3.29055L9.49902 12.2505L12.249 15.0005L21.209 6.04055C21.599 5.65055 21.599 5.02055 21.209 4.63055Z',
      key: '1tmn19',
    },
  ],
]);

export default Brush;
